import { Component, OnInit, OnChanges, OnDestroy, Output, EventEmitter, Input, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { CustomerService } from 'src/app/services/operations/customer.service';
import { IGetPermissionMandatoryField,IMiscellaneousSettingsDetails} from '../interface';
import { ICompetitorMarketRateDetail, ICompetitorUnitTypeMarketRate } from 'src/app/Shared/interface2';
import { CurrencyPipe } from '@angular/common';
import { ModalDirective, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';
// import { isString } from 'util';
import { ICostToReserveRentModel,IUnitInfo } from 'src/app/Shared/models/ProspectModel';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { type } from 'os';
@Component({
    selector: 'app-editRent',
    templateUrl: 'edit-Rent.component.html',
    styleUrls: ['edit-Rent.component.scss'],
    standalone: false
})
export class EditRentSharedComponent implements OnInit, OnChanges, OnDestroy {
  EditRentMandateFields;
  modifiedRentChangeField;
  curentRentField;
  modifiedRentField = false;
  editedRentNoteField = false;
  minimumRentEditLimit;
  maximumRentEditLimit;
  curentRent = 0;
  modifiedRent;
  standardRent = 0;
  editedRentNote = '';
  RentEditIncreaseLimit;
  RentEditDecreaseLimit;
  minRentEditLimitValue;
  maxRentEditLimitValue;
  RentDisplayMessage = '';
  disablesaveonKeypress: boolean = true;
  rentEditLimitRight: boolean = false;
  @Input() budgetedRent;
  @Input() editRentFormId;
  @Input() facilityId;
  @Input() miscelleaneousSetting;
  /** Story 5.2: optional — when provided, renders the competitor-rate section (Edit Rent / Modify Rent Raise only). */
  @Input() unitTypeId?: number;
  @Output() editedRentEmit: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('editRentModal', { static: true }) editRentModal: ModalDirective;
  modalConfig = {
    backdrop: 'static',
    keyboard: false
  };

  competitorMarketRate: ICompetitorUnitTypeMarketRate;
  selectedCompetitorRates: ICompetitorMarketRateDetail[] = [];
  competitorRateModalRef: BsModalRef;
  private competitorRateRequestId = 0;
  private readonly destroy$ = new Subject<void>();

  constructor(private generalService: GeneralService,
    private prospectService: ProspectService,
    private customerService: CustomerService,
    private currencyPipe: CurrencyPipe,
    private modalWrapper: ModalWrapperService,
    private modalService: BsModalService) { }

  ngOnInit(): void {
    this.setMandatoryField();
    if (!this.miscelleaneousSetting && this.facilityId) {
      this.getMiscellaneous();
    } else {
      this.maximumRentEditLimit = this.miscelleaneousSetting?.RentEditIncreaseLimit ?? null;
      this.minimumRentEditLimit = this.miscelleaneousSetting?.RentEditDecreaseLimit ?? null;
    }
    this.loadCompetitorMarketRate();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['facilityId'] && (!this.miscelleaneousSetting)) {
      this.getMiscellaneous();
    }
    if ((changes['facilityId'] || changes['unitTypeId']) && !changes['facilityId']?.firstChange) {
      this.loadCompetitorMarketRate();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.competitorRateModalRef?.hide();
  }

  loadCompetitorMarketRate(): void {
    // Drop any in-flight response and clear stale UI immediately on input change.
    const requestId = ++this.competitorRateRequestId;
    this.competitorMarketRate = null;

    if (!this.unitTypeId || !this.facilityId) {
      return;
    }
    this.customerService.getCompetitorMarketRateForUnitType(this.facilityId, this.unitTypeId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (rate) => {
          if (requestId !== this.competitorRateRequestId) {
            return;
          }
          this.competitorMarketRate = rate;
        },
        error: () => {
          if (requestId !== this.competitorRateRequestId) {
            return;
          }
          this.competitorMarketRate = null;
        }
      });
  }

  openCompetitorRateDetail(template: TemplateRef<any>): void {
    this.selectedCompetitorRates = this.competitorMarketRate?.CompetitorRates || [];
    this.competitorRateModalRef?.hide();
    this.competitorRateModalRef = this.modalService.show(template, { class: 'modal-md' });
  }

  checkDisabledForModifiedRent() {
    if (this.minimumRentEditLimit === 0 && this.maximumRentEditLimit === 0) {
      return true
    }
    return false
  }

  getDisabledForRentPopup() {
    const modifiedRentNumber = typeof this.modifiedRent === 'string' ? parseFloat(this.modifiedRent.replace('$', '')) : this.modifiedRent;
    return (this.curentRent == modifiedRentNumber || this.disablesaveonKeypress || this.editedRentNoteField && (!this.editedRentNote || this.editedRentNote.trim().length === 0));
  }

  numberOnly(event): boolean {
    this.disablesaveonKeypress = true;
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode >= 48 && charCode <= 57) {
      return true;
    }
    if (charCode === 46) {
      if (this.modifiedRent && this.modifiedRent !== "" && !this.modifiedRent.includes('.')) {
        return true;
      }
      return false;
    }
    return false;
  }


  getMiscellaneous() {
    this.prospectService.getFacilityMiscellaneousSettings(this.facilityId)
      .subscribe((response) => {
        this.miscelleaneousSetting = response;
        this.maximumRentEditLimit = this.miscelleaneousSetting?.RentEditIncreaseLimit ?? null;
        this.minimumRentEditLimit = this.miscelleaneousSetting?.RentEditDecreaseLimit ?? null;
      },
        (error) => {
          console.error('Error fetching the values: ', error);
        }
      );
  }

  emitEditedRent() {
    const obj = {
      OldRent: this.curentRent,
      NewRent: parseFloat(this.modifiedRent.replace(/[$,]/g, '')),
      Notes: this.editedRentNote,
      IsRentRaiseNotes: true
    };
    this.editedRentEmit.emit(obj);
    this.RentDisplayMessage = null;
  }

  clearValidationMessage() {
    if (this.editedRentNote && this.editedRentNote.trim() !== '') {
      this.RentDisplayMessage = null;
    }
  }

  onModifiedRentChange(data) {
    //this.modifiedRent = data;
    //if( this.modifiedRent.startsWith('$')){
    //  this.modifiedRent = this.modifiedRent.replace('$' , '');
    //}
    this.modifiedRent = data.replace(/\$/g, '').trim();
    if (this.curentRent !== Number(this.modifiedRent)) {
      this.editedRentNoteField = this.EditRentMandateFields.Form.ListOfProperties.find(o => o.Name === 'editedRentNote').Required;
    }
    if (this.minimumRentEditLimit !== 0 && this.maximumRentEditLimit !== 0) {
      this.modifiedRentField = this.EditRentMandateFields.Form.ListOfProperties.find(o => o.Name === 'ModifiedRent').Required;
    }

    if ((!this.minimumRentEditLimit && !this.maximumRentEditLimit) || !this.rentEditLimitRight) {
      this.RentDisplayMessage = null;
    } else {
      let minRentEditLimitValue: number;
      let maxRentEditLimitValue: number;
      if (this.minimumRentEditLimit === 0) {
        minRentEditLimitValue = this.standardRent;
      } else if (this.minimumRentEditLimit) {
        minRentEditLimitValue = this.standardRent - (this.standardRent * this.minimumRentEditLimit / 100);
      }
      if (this.maximumRentEditLimit === 0) {
        maxRentEditLimitValue = this.standardRent;
      } else if (this.maximumRentEditLimit) {
        maxRentEditLimitValue = this.standardRent + (this.standardRent * this.maximumRentEditLimit / 100);
      }
      this.minRentEditLimitValue = minRentEditLimitValue ? (Math.round(minRentEditLimitValue * 1000) / 1000).toFixed(2) : null;
      this.maxRentEditLimitValue = maxRentEditLimitValue ? (Math.round(maxRentEditLimitValue * 1000) / 1000).toFixed(2) : null;

      if (this.minimumRentEditLimit != null && this.maximumRentEditLimit != null) {
        this.RentDisplayMessage = 'Rent Edit Limit - Min:$' + this.minRentEditLimitValue + '. Max:$' + this.maxRentEditLimitValue + '.';
        if (this.modifiedRent < minRentEditLimitValue) {
          this.modifiedRent = minRentEditLimitValue;
        } else if (this.modifiedRent > maxRentEditLimitValue) {
          this.modifiedRent = maxRentEditLimitValue;
        } else {
          this.RentDisplayMessage = null;
        }
      } else if (!this.minimumRentEditLimit) {
        if (this.modifiedRent > maxRentEditLimitValue) {
          this.RentDisplayMessage = 'Rent Edit Limit - Max:$' + maxRentEditLimitValue + '.';
          this.modifiedRent = maxRentEditLimitValue;
        } else {
          this.RentDisplayMessage = null;
        }
      } else if (!this.maximumRentEditLimit) {
        this.RentDisplayMessage = 'Rent Edit Limit - Min:$' + minRentEditLimitValue + '.';
        if (this.modifiedRent < minRentEditLimitValue) {
          this.modifiedRent = minRentEditLimitValue;
        } else {
          this.RentDisplayMessage = null;
        }
      } else if (this.modifiedRent === this.curentRent) {
        this.RentDisplayMessage = null;
      } else {
        this.RentDisplayMessage = null;
      }
    }
  }

  isdisabledsave() {
    setTimeout(() => {
      this.disablesaveonKeypress = false;
    }, 600);
  }

  setCurrency() {
    this.modifiedRent = this.modifiedRent || 0;
    if (typeof this.modifiedRent === 'string') {
      this.modifiedRent = this.modifiedRent.replace(/[^0-9.]+/g, '');
    }
    this.modifiedRent = this.currencyPipe.transform(this.modifiedRent, '$');
  }

  onCancel() {
    this.modifiedRent = 0;
    this.editedRentNote = '';
    this.editedRentNoteField = null;
    this.RentDisplayMessage = null;
  }

  openModal() {
    this.modalWrapper.openDirective(this.editRentModal);
  }

  closeModal() {
    this.editRentModal.hide();
  }

  setMandatoryField() {
    this.generalService.GetMandatoryFieldsById(null, this.editRentFormId)
      .subscribe((response: IGetPermissionMandatoryField) => {
        this.EditRentMandateFields = response;
        this.curentRentField = this.EditRentMandateFields.Form.ListOfProperties.find(o => o.Name === 'Rent').Required;
      });
  }
}
